import SubscribableProduct from '../interfaces/subscribableProduct';
import { CADENCE_TYPE } from '../interfaces/subscriptions';

export const hasBoxSubscription = (subscribableProducts: SubscribableProduct) => {
  for (const key in subscribableProducts) {
    if (subscribableProducts[key].activeSubscription?.cadenceType === CADENCE_TYPE.GO_WITH_BOX) {
      return true;
    }
  }
  return false;
};
